import { ModelBase } from './model';

class ScormEvent extends ModelBase {
  static namespace = 'scorm_events';

  static cache = false;
}
export default ScormEvent.register();
